var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActionSmallList = function SvgActionSmallList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#038AB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.667 4H5.222C4.547 4 4 4.547 4 5.222v2.445c0 .675.547 1.222 1.222 1.222h2.445c.675 0 1.222-.547 1.222-1.222V5.222C8.889 4.547 8.342 4 7.667 4zM7.667 12.556H5.222c-.675 0-1.222.547-1.222 1.222v2.444c0 .675.547 1.222 1.222 1.222h2.445c.675 0 1.222-.547 1.222-1.222v-2.444c0-.675-.547-1.222-1.222-1.222zM7.667 21.111H5.222c-.675 0-1.222.547-1.222 1.222v2.445C4 25.453 4.547 26 5.222 26h2.445c.675 0 1.222-.547 1.222-1.222v-2.445c0-.675-.547-1.222-1.222-1.222zM11.333 5.222H26v2.444H11.333zM11.333 13.778H26v2.444H11.333zM11.333 22.333H26v2.444H11.333z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ActionSmallList.8bc3e45f3073ca59ef9ed6c28693c68e.svg";